import React from "react";
import { BoxIcon } from "lucide-react";
type Tone = 'info' | 'warning' | 'success';
const toneClasses: Record<Tone, string> = {
  info: 'border-[#B0CDF5] bg-sf-blue-light',
  warning: 'border-[#F9C88C] bg-sf-amber-light',
  success: 'border-[#91DB8B] bg-sf-green-light'
};
const iconClasses: Record<Tone, string> = {
  info: 'text-sf-blue',
  warning: 'text-sf-amber-text',
  success: 'text-sf-green'
};
interface ScopedNotificationProps {
  tone: Tone;
  icon: BoxIcon;
  action?: React.ReactNode;
  children: React.ReactNode;
}
export function ScopedNotification({
  tone,
  icon: Icon,
  action,
  children
}: ScopedNotificationProps) {
  return <div role="status" className={`flex items-center gap-3 rounded border px-3 py-2 text-[13px] text-sf-text ${toneClasses[tone]}`} data-id="element-893" data-mp="2t1leadxwfd6f">
      <Icon className={`h-4 w-4 shrink-0 ${iconClasses[tone]}`} aria-hidden="true" data-id="element-894" data-mp="20eh3fsc4k4mq" />
      <div className="min-w-0 flex-1" data-id="element-895" data-mp="20cedf8az2bi0">{children}</div>
      {action}
    </div>;
}